import React, { useCallback } from 'react';
import Modal from 'utils/packages/Modal';
import { SettingsItem, Spacer } from 'design-system';
import IconTransfer from 'design-system/icons/IconTransfer';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { IconMoneyBag } from 'design-system/icons';
import { AccountTypeDisplay } from '../constants';
import { selectTradingAccount } from '../reducers/selectors';
const SellSecclAssetOptionsModalContent = ({ assetId }) => {
    const navigation = useMainStackNavigation();
    const tradingAccount = useAppSelector(selectTradingAccount);
    const handleSwitch = useCallback(() => {
        Modal.hide(() => {
            if (assetId) {
                navigation.navigate('InvestAssetSwitch', { assetId });
            }
            else {
                navigation.navigate('BeforeYouSell', { sellType: 'switch' });
            }
        });
    }, [assetId]);
    const handleSell = useCallback(() => {
        Modal.hide(() => {
            if (assetId) {
                navigation.navigate('InvestSell', { assetId });
            }
            else {
                navigation.navigate('BeforeYouSell', { sellType: 'cash' });
            }
        });
    }, [assetId]);
    return (<>
      <Spacer h={8}/>
      <SettingsItem onPress={handleSwitch} icon={<IconTransfer />} title="Switch to another investment" description="Sell and reinvest in one smooth flow"/>
      <SettingsItem title="Hold as cash" onPress={handleSell} icon={<IconMoneyBag colorKey="brand"/>} description={`Keep the proceeds in your ${AccountTypeDisplay[tradingAccount?.account.accountType || 'GIA']} for future investing`}/>
    </>);
};
export default SellSecclAssetOptionsModalContent;
